import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { css } from "@emotion/react"

export default () => (
  <StaticQuery
    query={graphql`
      query imageConventionneEnQuery {
        file(
          relativePath: {
            eq: "chirurgien-membre-superieur-conventionne-paris.jpg"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 800) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => (
      <Img
        fluid={data.file.childImageSharp.fluid}
        alt="Agreed upper limb surgeon (
                     sector 2) in Paris."
        css={css`
          margin-top: 6px;
        `}
      />
    )}
  />
)
